module.exports = __webpack_public_path__ + "img/ama_long@3x.3b10d78e.png";